import React from 'react';
import { Flex, Img, Heading } from 'pounceV2';
import EmptyState from 'Assets/illustrations/nodification-sidedrawer-empty-state.svg';

const NotificationsEmptyStateV3 = () => {
  return (
    <Flex mt={30} align="center" justify="center" direction="column">
      <Img mb={6} src={EmptyState} alt="Empty State" nativeWidth={132} nativeHeight={132} />
      <Heading variant="h4" mb={2}>
        You&apos;re up-to-date!
      </Heading>
    </Flex>
  );
};

export default NotificationsEmptyStateV3;
